import React from "react";
import Skeleton from "react-loading-skeleton";
import { formatNumber } from "../../utils/data/essential";
import { Link } from "react-router-dom";

const PendingAccountsCard = ({ accountsData }) => {
  return (
    <div className='card mt-3 dashboard-card-width'>
      <div>
        <div className='d-flex justify-content-center'>
          <h4>Abiyanditse bashya </h4>
        </div>
        <div className='d-flex justify-content-between mt-3'>
          <div className='d-flex flex-column' style={{ gap: "10" }}>
            <h5 style={{ color: "#696060" }}>Bose </h5>
            <h6 className='ml-1' style={{ color: "#3a0ca3", fontSize: 20 }}>
              <b>
                {accountsData ? (
                    <b>
                      {formatNumber(accountsData?.selfRegistrationAccounts)}
                    </b>
                ) : (
                  <Skeleton />
                )}
              </b>
            </h6>
          </div>
          <Link to={`/loggedin/pending-accounts/${accountsData?.locationId}`}>
            <div className='d-flex flex-column' style={{ gap: "10" }}>
              <h5 style={{ color: "#696060" }}>Ayishyuwe </h5>
              <h6 className='ml-1' style={{ color: "#3a0ca3", fontSize: 20 }}>
                <b>
                  {accountsData ? (
                    formatNumber(accountsData?.selfRegistrationTotalCollections)
                  ) : (
                    <Skeleton />
                  )}
                </b>
              </h6>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PendingAccountsCard;
